export default "__VITE_ASSET__DDTrmPOw__"